import Bluebird = require("bluebird");
import { inject, injectable } from "inversify";
import TYPES from "../TYPES";
import { ConsoleUI } from "../utils/ConsoleUI";
import { KotennaApi } from "../lib/kotenna/KotennaApi";
import { Alias } from "../lib/kotenna/Alias";

declare global { export interface Promise<T> extends Bluebird<T> {} }
Promise = Bluebird as any;

const delay = (time) => (result) => new Promise(resolve => setTimeout(() => resolve(result), time));


@injectable()
export class AliasWorker {

    private console: ConsoleUI;
    private api: KotennaApi;

    constructor(
       @inject(TYPES.ConsoleUI) ui: ConsoleUI,
       @inject(TYPES.KotennaApi) api: KotennaApi
    ) {
        this.api = api;
        this.console = ui;
    }

    async delete(aliasname: string|string[], forceDelete = false) {

        if(!aliasname) {
            this.console.loaderStart("Loading Alias");
            const list = await this.api.alias();
            const choices = list.map(v => {
                return {
                    name: `${v.aliasname} - ${v.hostname}`,
                    value: v.aliasname
                }
            });
            aliasname = await this.console.promptCheckbox("Choose which Alias to delete", choices);
            console.log(aliasname);
        }

        if(!Array.isArray(aliasname)) {
            aliasname = [aliasname];
        }

        if(!forceDelete) {
            const go = await this.console.promptConfirm(`Deleting Alias ${aliasname} (the Cloud Instance will NOT be affected in any way) - Confirm?`);
            if(!go) {
                throw new Error ("User cancelled");
            }
        }

        return Promise.resolve(aliasname.map(name => this.api.aliasDelete(name)));
    }

    async update(aliasname: string, change: string): Promise<Alias> {

        this.console.loaderStart("Loading Alias");
        const list = await this.api.alias();

        const alias = list.filter(v => v.aliasname === aliasname)[0];

        if(!alias) {
            return Promise.reject(`Alias ${aliasname} not found`);
        }

        const tmp = change.split("=");
        const path = tmp[0];
        const value = tmp[1].replace(/"/g, '');

        // source: https://stackoverflow.com/questions/18936915/dynamically-set-property-of-nested-object
        function set(path, value, obj) {
            let schema = obj;  // a moving reference to internal objects within obj
            const pList = path.split('.');
            const len = pList.length;
            for(let i = 0; i < len - 1; i++) {
                const elem = pList[i];
                if( !schema[elem] ) schema[elem] = {}
                schema = schema[elem];
            }
            schema[pList[len - 1]] = value;
        }

        set(path, value, alias);

        this.console.loaderStart("Updating Alias");
        return this.api.aliasSave(alias);

    }


    list(): Promise<Alias[]|Error> {
        this.console.loaderStart("Loading Alias");
        return this.api.alias();
    }

    async create(): Promise<Alias> {

        this.console.loaderStart("Loading Vhosts");
        const vhosts = await this.api.vhost();
        const vhost = await this.console.promptList("Choose a VHost", vhosts.map((i, index) => { return { value: i, name: i.hostname }; }));

        let  aliasname = await this.console.promptInput("Please specify a domain name for the Alias");
        aliasname = aliasname.replace(/http(s?):\/\//,'');

        this.console.log(`Creating Alias for ${vhost.hostname} with FQDN ${aliasname}`);

        this.console.loaderStart("Alias is cooking...");
        return this.api.aliasSave({
            aliasname,
            hostname: vhost.hostname,
            options: {}
        });

    }


}